<template>
    <div>

        <h2 class="text-light">/>Corridor  <button @click="logout" class="logout btn btn-outline-danger">Logout</button></h2>
        
        <hr style="border: 1px solid #333;">

        

        <span>
            <img class="rounded-circle mr-2" height="30" :src="currentUser.photoURL" />
            <span class="text-light">{{ currentUser.displayName }}</span> 
        </span>

        <hr style="border: 1px solid #333;">

        
        <!-- log out used to be here -->
        <!-- <hr style="border: 1px solid #333;"> -->

        <channels></channels>

        <hr style="border: 1px solid #333;">

        <users></users>

    </div>
</template>

<script>
import auth from 'firebase/auth'
import {mapGetters} from 'vuex'
import Channels from './Channels'
import Users from './Users'
import database from 'firebase/database'

    export default {
        name: 'sidebar',

        components: {Channels, Users},

        data() {
            return {
                presenceRef: firebase.database().ref('presence')
            }
        },

        computed: {
            ...mapGetters(['currentUser'])
        },

        methods: {
            logout() {
                this.presenceRef.child(this.currentUser.uid).remove()
                firebase.auth().signOut()
                this.$store.dispatch('setUser', null)
                this.$router.push('/login')
            }
        }
    }
</script>










<style scoped>
.logout{border-radius: 50px;
margin-left:40%;}

</style>










// WEBPACK FOOTER //
// src/sidebar/Sidebar.vue